<template>

  <div id="algolia-content-container home-page" class="padding-fix relative clearfix home-page">
<!--    <div  class="py-2"><span>Showing results for ZIP Code: <b>{{deliveryAddress.post_code}}</b></span></div>-->
    <div v-if="showSlider">
      <swiper id="swiper-wrapper" :options="swiperOption" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl" >

        <swiper-slide v-for="(slide, index) in contents" :key="index">

          <vx-card class="p-0 overflow-hidden">
            <div class="swipe-image-wrapper  bg-white flex items-center justify-center cursor-pointer product-image"
                 v-bind:style="{ 'background-image': 'url(' + slide.contentImageUrl + ')' }">
            </div>
            <div class="p-absolute bg-filter"></div>
            <div class="description-wrapper">
              <span v-if="showSlideContent" class="description title-font">{{slide.name}}</span>
              <span v-if="showSlideContent" class="description-content">
                <p>
                  {{slide.shortContent}}
                </p>
              </span>
            </div>
          </vx-card>
        </swiper-slide>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>

    <!-- RIGHT COL -->

    <h1 class="text-primary mt-4" >Catering Restaurants</h1>
        <!-- GRID VIEW -->
    <catering-tabs-all> </catering-tabs-all>
    <div v-if="showRestofThePage">
      <h3 class="text-primary mt-4" >Deals You Might Like</h3>
      <page-content-pages class="mt-4"/>
      <h3 class="text-primary mt-4" >Restaurant Videos</h3>
      <video-content-pages :videos="videos" class="mt-4"/>
      <blog-content-pages />
    </div>
  </div>

</template>

<script>
import CateringTabsAll from '../tabs/components/CateringTabsAll'
import {swiper, swiperSlide} from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import SearchBar from '../../../layouts/components/navbar/components/SearchBar'
import PageContentPages from './components/PageContentPages'
import BlogContentPages from '../blog/components/BlogContentPages'
import VideoContentPages from './components/VideoContentPages'

export default {
  components: {
    SearchBar,
    CateringTabsAll,
    swiper,
    swiperSlide,
    PageContentPages,
    VideoContentPages,
    BlogContentPages
  },
  metaInfo () {
    return {
      title: 'Turkish Restaurant',
      titleTemplate: '%s',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Turkish Restaurant is a unique portal where you can find the most delicious traditional Turkish dishes of the United States.'
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: 'Turkish Mediterranean Cuisine'
        }
      ]
    }
  },
  data () {
    return {
      // Filter Sidebar
      isFilterSidebarActive: true,
      clickNotClose: true,
      refresh: false,
      showRestofThePage: false,
      showSlideContent: false,
      videos: [
        'OxvX8jk9LME',
        'eA5tOz9Ms9I',
        'fHFoTswcff4'
      ],
      numericItems: [
        { label: 'All' },
        { label: '<= $10', end: 10 },
        { label: '$10 - $100', start: 10, end: 100 },
        { label: '$100 - $500', start: 100, end: 500 },
        { label: '>= $500', start: 500 }
      ],
      showSlider: false,
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: (this.isMobile) ? 0 : 30,
        slidesPerGroup: 1,
        autoplay: {
          delay: 3000,
          disableOnInteraction: true
        },
        speed: 1500,
        loop: true,
        loopFillGroupWithBlank: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      algoliaCategories: [
        'hierarchicalCategories.lvl0',
        'hierarchicalCategories.lvl1',
        'hierarchicalCategories.lvl2',
        'hierarchicalCategories.lvl3'
      ]
    }
  },
  computed: {
    scrollY () {
      return this.$store.state.scrollY
    },
    toValue () {
      return (value, range) => [
        value.min !== null ? value.min : range.min,
        value.max !== null ? value.max : range.max
      ]
    },
    // GRID VIEW
    isInCart () {
      return (itemId) => this.$store.getters['eCommerce/isInCart'](itemId)
    },
    isInWishList () {
      return (itemId) => this.$store.getters['eCommerce/isInWishList'](itemId)
    },
    windowWidth () { return this.$store.state.windowWidth },
    isMobile () {
      return this.$store.state.api.isMobile
    },
    showSearch () {
      return this.$store.state.api.showSearch
    },
    deliveryAddress () {
      return this.$store.state.api.deliveryAddress
    },
    contents () {
      return this.$store.state.api.contents
    },
    currentUser () {
      return this.$store.state.api.currentUser
    }
  },
  watch: {
    windowWidth () {
      this.setSidebarWidth()
    },
    deliveryAddress () {
    },
    scrollY () {
      if (this.scrollY < -1) {
        this.showRestofThePage = true
      }
    }
  },
  methods: {
    getContentList () {

      this.$vs.loading()

      const payload = {
        contentType: 'slide',
        isHome: 1,
        page:'1',
        limit:'20'
      }

      this.$store.dispatch('api/contentList', payload)
        .then(() => {
          this.$vs.loading.close()
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })

    },

    setSidebarWidth () {
      if (this.windowWidth < 992) {
        this.isFilterSidebarActive = this.clickNotClose = false
      } else {
        this.isFilterSidebarActive = this.clickNotClose = true
      }

    },

    // GRID VIEW - ACTIONS
    toggleFilterSidebar () {
      if (this.clickNotClose) return
      this.isFilterSidebarActive = !this.isFilterSidebarActive
    },
    toggleItemInWishList (item) {
      this.$store.dispatch('eCommerce/toggleItemInWishList', item)
    },
    additemInCart (item) {
      this.$store.dispatch('eCommerce/additemInCart', item)
    }
  },
  created () {
    this.setSidebarWidth()
    if (this.contents.length === 0) {
      this.getContentList()
    }
  },
  destroyed () {
    this.$store.commit('api/SET_SHOW_SEARCH', false)
  },
  mounted () {
    setTimeout(() => { this.showSlider = true }, 1000)
  },
  beforeMount () {
    this.$store.commit('api/SET_SHOW_SEARCH', true)
    this.$store.commit('TOGGLE_IS_SIDE_MENU_ACTIVE', false)
    this.$store.dispatch('updateSideMenuWidth', 'no-nav-menu')
    //this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
    //this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')

  }
}
</script>


<style lang="scss">
.desktop-off {
  display:none;
}
.tr-shorts-cont{
  width:100%;
  padding:20px;
}
.tr-shorts-row{
  display:flex;
  flex-wrap: wrap;
  margin-bottom:50px;
}

.tr-shorts-col {
  img{
    max-width:100%;
  }
}
.tr-shorts-col.with-text{
  h2{
    font-size:40px;
    font-weight: 900;
    margin-bottom:20px;
  }
  p{
    font-size:22px;
    color:#333;
  }
  width:60%;
  display:flex;
  flex-direction:column;
  justify-content: center;
  padding-right:20px;
}
.tr-shorts-row:nth-child(2) .with-text{
  text-align: right;
  padding-left:20px;
  padding-right:0px;
}
.tr-shorts-col.with-image{
  width:40%;
}
.tr-shorts-row:nth-child(2){
  flex-direction: row-reverse;
}
.tr-featurette {
  width:100%;
  display:flex;
  justify-content: space-between;
  margin-bottom:50px;
}
.tr-featurette-column{
  width:calc(33% - 10px);
}
.tr-featurette-icon {
    margin:0 auto;
  width:150px;
}
.tr-featurette-text {

  h2{
    font-size:24px;
    font-weight:bold;
    margin-bottom:20px;
  }
  text-align:center;
  font-weight: bold;
  font-size:19px;
  display:flex;
  justify-content: center;
  flex-wrap: wrap;
}
.tr-featurette-button {
  margin-top:20px;
  padding:5px 10px;
  width: max-content;
  background-color:#ff2400;
  color:#fff;
  cursor:pointer;
}
@media (max-width:768px){
  .mobile-off {
    display:none;
  }
  .desktop-off {
    display:block;
    margin-top:20px;
  }
  .tr-shorts-cont{
    padding:20px 0 0 0;
  }
  .tr-shorts-col.with-image, .tr-shorts-col.with-text{
    width:100%;
  }
  .tr-shorts-col.with-text{
  h2{
    font-size:22px;
    font-weight: 900;
    margin-bottom:15px;
  }
  p{
    font-size:16px;
    color:#333;
    margin-bottom:15px;
  }
  display:flex;
  flex-direction:column;
  justify-content: center;
  padding-left:0px;
}
.tr-shorts-row:nth-child(2) .with-text{
  text-align: left;
  padding-left:0;
  padding-right:0;
}
  .tr-featurette-column{
  width:100%;
}
.tr-featurette {
  flex-direction: column;
}
}
  .mobile .content-area__content {
    max-width: 100%;
  }

  .swiper-container {
    overflow: hidden;
    position: relative;
    margin-bottom:20px;
  }
  .home-page {


    .bg-filter {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      position: absolute;
    }
    .swipe-image-wrapper {
      width: 100%;
      height: 470px;
      background-size:cover;
      background-position: center;
    }
    #algolia-instant-search-demo {
      .algolia-header {
        .algolia-filters-label {
          width: calc(260px + 2.4rem);
        }
      }

      #algolia-content-container {

        .vs-sidebar {
          position: relative;
          float: left;
        }
      }

      .algolia-search-input-right-aligned-icon {
        padding: 1rem 1.5rem;
      }

      .algolia-price-slider {
        min-width: unset;
      }

      .item-view-primary-action-btn {
        color: #2c2c2c !important;
        background-color: #f6f6f6;
        min-width: 50%;
      }

      .item-view-secondary-action-btn {
        min-width: 50%;
      }
    }

    .theme-dark {
      #algolia-instant-search-demo {
        #algolia-content-container {
          .vs-sidebar {
            background-color: #10163a;
          }
        }
      }
    }

    @media (min-width: 992px) {
      .vs-sidebar-rounded {
        .vs-sidebar {
          border-radius: .5rem;
        }

        .vs-sidebar--items {
          border-radius: .5rem;
        }
      }
    }

    @media (max-width: 992px) {
      #algolia-content-container {
        .vs-sidebar {
          position: absolute !important;
          float: none !important;
        }
      }
    }

    .splide__slide img{
      border-radius: 25px;
    }
    .splide__slide .image-wrapper {
      margin: 0 auto;
      padding: 30px 0px;
    }
    .splide__slide .image-with-bg {
      width: 100%;
      height: 300px;
      margin: 0 auto;
      max-height: 300px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: right;
    }
    .splide__slide__container{
      border-radius: 25px;
    }
    .items-grid-view .vx-col {
      padding: 1rem 1rem 1rem 0;
    }
    .mid-weight {
      font-weight: 500;
    }
    .swiper-wrapper .vx-card .vx-card__body {
      padding: 0 !important;
    }
    .swiper-wrapper .description-content {
      color:white;
      font-size:1.25rem;
    }
    .swiper-wrapper .description {
      color:white;
      font-size:2.5rem;
    }
    .swiper-wrapper .description-wrapper {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .swiper-button-next {
      right: 15px;
    }
    .swiper-button-prev {
      left: 15px;
    }
    .swiper-button-prev, .swiper-button-next {
      margin-top: 0;
      cursor: pointer;
      transform: scale(.5);
      background: white;
      color: #626262;
      border-radius: 6px;
      padding: 35px 30px;
      top: calc(235px - var(--swiper-navigation-size)/2) !important;
    }


  }


  .mobile {
    .home-page {

      .items-grid-view .vx-col {
        padding-right: 0;
      }
      .swiper-button-prev {
        background: white;
        color: black;
        left: 0px;
      }
      .swiper-button-next {
        background: white;
        color: black;
        right: 0px;
      }
      .swiper-wrapper .description-content {
          color:white;
          font-size:1.05rem;
        }
      .swiper-wrapper .description {
        color:white;
        font-size:1.5rem;
      }
    }
  }
  @media (max-width:768px){
    .home-page {
    .swipe-image-wrapper {
      width: 100%;
      height: 200px;
      background-size:cover;
      background-position: center;
    }
    .swiper-button-prev, .swiper-button-next {
      margin-top: 0;
      cursor: pointer;
      transform: scale(.5);
      background: white;
      color: #626262;
      border-radius: 6px;
      padding: 35px 30px;
      top: calc(90px - var(--swiper-navigation-size)/2) !important;
    }
    }
    .trlistinfo p {
      font-size:9px;
    }
  }
</style>
